import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useBenefisUIContext } from "../BenefisUIContext";
import { BenefisEditDialogHeader } from "./BenefisDialogHeader";
import { BenefisIndividuEditForm } from "./BenefisIndividuEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/benefis/benefisAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { BenefisOrganizationEditForm } from "./BenefisOrganizationEditForm";
import LoadingAnimation from "../../../Donation/pages/import-mutation-bank/loading-animation/LoadingAnimation";
import { BenefisProfileForm } from "../benefis-profile/BenefisProfileForm";

export const BenefisEditDialog = ({
  history,
  match: {
    params: { type, id },
  },
}) => {
  const [tab, setTab] = useState("basic");

  // Benefis UI Context
  const benefisUIContext = useBenefisUIContext();
  // const benefisUIProps = useMemo(() => {
  //   return {
  //     initBenefis: benefisUIContext.initBenefis,
  //     queryParams: benefisUIContext.queryParams,
  //     setQueryParams: benefisUIContext.setQueryParams,
  //   };
  // }, [benefisUIContext]);

  // Benefis Redux state
  const dispatch = useDispatch();
  const { actionsLoading, benefisForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.benefis.actionsLoading,
      benefisForEdit: state.benefis.benefisForEdit,
      error: state.benefis.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Benefis by id
    dispatch(actions.fetchBenefis(id));
  }, [id, dispatch]);

  const saveBenefis = (benefis) => {
    // ? Define Create or Edit
    if (!id) {
      dispatch(actions.createBenefis(benefis)).then((response) => {
        toast.success(response.message, toastOption);
        history.push("/_distribution/benefis");
      });
    } else {
      dispatch(actions.updateBenefis(benefis)).then((response) => {
        toast.success(response.message, toastOption);
        history.push("/_distribution/benefis");
      });
    }
  };

  const updateProfile = (values) => {
    const { json_profile } = values;
    dispatch(actions.updateBenefis({ ...benefisForEdit, json_profile })).then(
      (response) => {
        toast.success(response.message, toastOption);
        history.push("/_distribution/benefis");
      }
    );
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader
          title={
            type === "individual"
              ? "Penerima Manfaat Individu"
              : "Penerima Manfaat Kelompok"
          }
        >
          <CardHeaderToolbar>
            <button
              className="btn btn-secondary"
              onClick={() => history.push("/_distribution/benefis")}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ul className="nav nav-tabs nav-tabs-line " role="tablist">
            <li className="nav-item" onClick={() => setTab("basic")}>
              <a
                className={`nav-link ${tab === "basic" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "basic").toString()}
              >
                Info Dasar
              </a>
            </li>
            {id && benefisForEdit && benefisForEdit.type !== "ORGANIZATION" && (
              <li className="nav-item" onClick={() => setTab("profile")}>
                <a
                  className={`nav-link ${tab === "profile" && "active"}`}
                  data-toggle="tab"
                  role="tab"
                  aria-selected={(tab === "profile").toString()}
                >
                  Profile
                </a>
              </li>
            )}
          </ul>
          {type === "individual" && (
            <div className="mt-5">
              {tab === "basic" && (
                <BenefisIndividuEditForm
                  saveBenefis={saveBenefis}
                  actionsLoading={actionsLoading}
                  benefis={benefisForEdit || {}}
                  id={id}
                />
              )}
              {tab === "profile" && (
                <BenefisProfileForm
                  saveBenefis={updateProfile}
                  benefis={
                    (benefisForEdit.json_profile &&
                      JSON.parse(benefisForEdit.json_profile)) ||
                    {}
                  }
                />
              )}
            </div>
          )}

          {type === "organization" && (
            <div className="mt-5">
              {/* {tab === "basic" && ( */}
              <BenefisOrganizationEditForm
                saveBenefis={saveBenefis}
                actionsLoading={actionsLoading}
                benefis={benefisForEdit || {}}
                id={id}
              />
              {/* )} */}
            </div>
          )}
        </CardBody>
      </Card>
    </>
    // <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
    //   <BenefisEditDialogHeader id={id} />
    //   <BenefisEditForm
    //     saveBenefis={saveBenefis}
    //     actionsLoading={actionsLoading}
    //     benefis={benefisForEdit || benefisUIProps.initBenefis}
    //     onHide={onHide}
    //   />
    // </Modal>
  );
};
